import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { Button } from "@/components/ui/button";
import { CloudArrowUpRegular, SpinnerIosRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  isSavingDraft: boolean;
  isPublishing: boolean;
  onSaveDraft: () => void;
  onPublish: () => void;
}

function Heading({
  onSaveDraft,
  onPublish,
  isPublishing,
  isSavingDraft,
}: HeadingProps) {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: "Regular assessment",
      href: "/console/regular-assessments",
    },
    {
      name: "Create new test",
      href: "/console/regular-assessments/create",
    },
  ];

  return (
    <div className="z-30 border-b bg-white">
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className="flex justify-between px-6 py-8">
        <div className="my-heading">{t("regular-assessment")}</div>
        <div className="flex gap-4">
          <Button variant="ghost">{t("cancel")}</Button>
          <Button
            variant="outline"
            isLoading={isSavingDraft}
            LoadingComponent="Saving..."
            onClick={onSaveDraft}
          >
            {t("save-draft")}
          </Button>
          <Button
            LoadingComponent={
              <div className="flex items-center">
                <SpinnerIosRegular className="animate-spin" />
                <span>{t("publishing...")}</span>
              </div>
            }
            isLoading={isPublishing}
            onClick={onPublish}
          >
            <CloudArrowUpRegular className="mr-2" fontSize={20} />
            {t("publish")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Heading;
